// Generated by ReScript, PLEASE EDIT WITH CARE


let code = (e => e?.code);

export {
  code,
}
/* No side effect */
